import { useEffect } from 'react';

import { UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { PageStore, WidgetStore } from '@kaltura-ott/tvpil-shared';

import { globalStorage } from 'services/globalStorage';

function BaseInitHook({ store, presentPlayer }: { store: PageStore; presentPlayer: boolean }) {
  useEffect(() => {
    globalStorage.setDisableMaxiPlayer(true);

    (async () => {
      if (store) {
        await store.init();

        const containHero = store.groupedWidgets?.widgets.some(
          (widget: WidgetStore) => widget.subtype === UIDAPresentationTypeEnum.hero,
        );

        if (!containHero && store.presentPlayer) {
          globalStorage.setIsMaxiLoading(false);
        }
      }
    })();
  }, [store]);

  useEffect(() => {
    if (!presentPlayer) {
      globalStorage.setPossiblePresentPlayer(false);
    }

    return () => {
      globalStorage.setPossiblePresentPlayer(false);
    };
  }, []);

  return null;
}

export { BaseInitHook };
